import { lazy } from "react"

const DiscordCallbackPage$$__react__lazy__component = lazy(() => 
    import("./DiscordCallbackPage__original__module.mjs")
        .then(module => module.get_$$DiscordCallbackPage$$DiscordCallbackPage$$react__component$$yttz7j04kvsc())
        .then(component => ({ default: component }))
)

export const get_$$DiscordCallbackPage$$DiscordCallbackPage$$react__component$$yttz7j04kvsc = () => DiscordCallbackPage$$__react__lazy__component